module.exports = __webpack_public_path__ + "img/e7a4a4a.jpg";